import React from 'react';
import { Table, Checkbox, Button } from 'semantic-ui-react'

class PublisherTableRow extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rowObj:{}
    };
  }

  componentWillMount() {
    const { objKey, rootNode, rootData } = this.props;
    const rowObj = rootData[objKey];
    this.setState({objKey, rootNode, rowObj})
  }

  changeHandler = (e, { name, checked }) => {
    e.preventDefault();
    const rowObj = {...this.state.rowObj};

    rowObj[name] = checked;
    this.setState({rowObj});
  };

  getEndPntForValidation = (rootNode) => {
    let result = [];
    switch (rootNode) {
      case 'channels':
        result.push('actionId', 'tagsSys');
        break;
      case 'actions':
        result.push('reqIds', 'howToIds');
        break;
      case 'requirements':
        result.push('reqTypeId');
        break;
      default:
        console.error('invalid Root node presented');
    }
    return result;
  };

  endPntIsValid = (endpointData) => {
    return (endpointData && endpointData.length > 0) ? true : false
  };

  buildValiditySentence = (endPntKey) => {
   return  `Has ${endPntKey}: ${this.endPntIsValid(this.state.rowObj[endPntKey])},`
  };


  render() {
    const { objKey, rootNode, rowObj } = this.state;
    const validationArr = this.getEndPntForValidation(rootNode);
    const validitySentence = validationArr.map(this.buildValiditySentence);
    const itemHasError = validationArr.map(el => this.endPntIsValid(rowObj[el])).includes(false);

    return (
    <Table.Row positive={!itemHasError} key={objKey}>
      <Table.Cell> { rootNode } </Table.Cell>
      <Table.Cell> { rowObj.name } </Table.Cell>
      <Table.Cell> <Checkbox name='published' onChange={this.changeHandler} checked={rowObj.published} /></Table.Cell>
      <Table.Cell error={itemHasError}> { validitySentence } </Table.Cell>
      <Table.Cell> { rowObj.key } </Table.Cell>
      <Table.Cell>
        <Button basic icon='plus' disabled={itemHasError} onClick={(e) => this.props.addToPublishingStack(rowObj, rootNode)} /> 
      </Table.Cell>
    </Table.Row>
  )}
};

export default PublisherTableRow;



// WEBPACK FOOTER //
// ./src/components/forms/PublisherTableRow.js